import { Fragment } from 'react'
import { FaPlus } from 'react-icons/fa'

import {
  Container,
  ScheduleInfo,
  PlusIcon,
  Row,
  Image,
  SubTitle,
  InfoText
} from './styles'

export default function ScheduleOption ({
  data: optionsData,
  onSelect
}) {
  const handleSelect = () => {
    if (Array.isArray (optionsData)) onSelect ({ combinationOptions:optionsData })
    else onSelect ({ scheduleOption: optionsData })
  }

  if (Array.isArray (optionsData)) {
    return (
      <Container onClick={handleSelect}>
        {optionsData.map ((schedule, index) => (
          <Fragment key={index}>
            <ScheduleInfo>
              <SubTitle>{schedule.time}</SubTitle>
              <Row>
                <SubTitle>{schedule.service.name}</SubTitle>
                <InfoText>com</InfoText>
                <SubTitle>{schedule.professional.nickname}</SubTitle>
              </Row>
              <Image src={schedule.professional.profile_picture}/>
            </ScheduleInfo>
            {index !== optionsData.length - 1 && (
              <PlusIcon>
                <FaPlus size={14} color='#FFC100'/>
              </PlusIcon>
            )}
          </Fragment>
        ))}
      </Container>
    )
  }

  return (
    <Container onClick={handleSelect}>
      <ScheduleInfo style={{borderWidth: 0, backgroundColor: 'transparent'}}>
        <SubTitle>{optionsData.time}</SubTitle>
        <Row>
          <SubTitle>{optionsData.service.name}</SubTitle>
          <InfoText>com</InfoText>
          <SubTitle>{optionsData.professional.nickname}</SubTitle>
        </Row>
        <Image src={optionsData.professional.profile_picture}/>
      </ScheduleInfo>
    </Container>
  )
}
